function datesWithin24Hours(date1: Date, date2: Date | null): boolean {
  if (!date2) return true;

  const diffInMilliseconds = Math.abs(
    date1.getTime() - (date2?.getTime() || new Date().getTime())
  );
  const hoursDifference = diffInMilliseconds / (1000 * 60 * 60); // Convert in hours

  return hoursDifference < 24;
}

export { datesWithin24Hours };
